import Checkbox from '@eversports/react-components/primitives/Checkbox'
import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import PyroForm from 'pyro-form'
import React from 'react'

import { Localized } from '../../../localization/react'
import { PoliciesInitialValues, Policy as PolicyType } from '../../../typings/AdditionalInformation'

import Policy from './Policy'
import Venue from './Venue'

interface Props {
  venueName: string
  policies: Array<PolicyType>
  initialValues: PoliciesInitialValues
  handleChange: (policies: PoliciesInitialValues) => void
}

const PoliciesComponent: React.FC<React.PropsWithChildren<Props>> = ({
  venueName,
  policies,
  initialValues,
  handleChange,
}) => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Text color="subtleText" fontWeight="bold" textTransform="uppercase">
      <Localized id="additional-info-policies-terms-of" params={{ venueName }} />
    </Text>
    <PyroForm initialValues={initialValues} onChange={handleChange}>
      <>
        <Text>
          <Localized
            id="additional-info-policies-please-accept-terms"
            params={{ venue: <Venue venue={venueName} /> }}
          />
        </Text>
        <Flex flexDirection="column">
          {policies.map((policy, index) => (
            <Checkbox
              key={policy.id}
              value={policy.id}
              name="policies"
              label={
                <Localized
                  id="additional-info-policies-i-accept-the-term"
                  params={{ policy: <Policy {...policy} />, venue: <Venue venue={venueName} /> }}
                />
              }
              data-testid={`venue-policy-${index}`}
            />
          ))}
        </Flex>
      </>
    </PyroForm>
    <Text>
      <Localized id="additional-info-policies-when-you-book-online" params={{ venueName }} />
    </Text>
    <Text>
      <Localized id="additional-info-policies-eversports-gets" params={{ venueName }} />
    </Text>
  </Flex>
)

export default PoliciesComponent
